import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';

import {
  Wrapper,
  StyledContainer,
  StyledLink,
  Columns,
  Block,
  Content,
  OptionalImage,
} from './styles';

// * Component {string} The name of the component / className that should render this data
// * colourOverRideTrext {string} A value of Light or Dark that determines what style of text we should use
// * colourOverrideBackground {string} A hexvalue of what the bg color should be
// * buttonLink {string} the url for the button / link
// * buttonText {string} the innertext for the button
// * buttonType {string} style for the cta
// * sectionTitle {string} headineg for the section
// * items {array} array of cms data (obj) that make up each data item
// * image {obj} data for the img, has url and alt

function DataSection({ data }) {
  if (!data) return null;
  const {
    component,
    columnCount,
    colourOverrideText,
    colourOverrideBackground,
    buttonLink,
    buttonText,
    buttonType,
    sectionTitleHtml,
    items,
    image,
    imageSharp,
    focusTextColour,
    ariaLabelButton,
    queryStringButton,
    imageBackground,
    imageBackgroundSharp,
    lang,
  } = data;
  const type = image.url ? 'with-image' : '';

  const textColor = colourOverrideText
    ? `text-${colourOverrideText.toLowerCase()}`
    : 'text-Light';

  const style = component ? component.toLowerCase().split(' ').join('-') : '';

  return (
    <Wrapper
      className={[style, textColor]}
      colourOverrideBackground={colourOverrideBackground}
      background={
        imageBackgroundSharp
          ? imageBackgroundSharp.publicURL
          : imageBackground.url
      }
    >
      <StyledContainer className={['auto-margin', type]}>
        {ReactHtmlParser(sectionTitleHtml)}
        <Columns className="regular-columns" columns={columnCount || 3}>
          {items.map(
            (
              {
                itemHeadingHtml,
                itemSubHeadingHtml,
                itemBodyCopyHtml,
                focusText,
                ctaText,
                cta,
                ariaLabel,
                queryString,
              },
              index,
            ) => (
              <Block
                text={focusText}
                focusTextColour={focusTextColour}
                key={`data-item-${focusText}-${index.toString()}`}
              >
                <Content>
                  {ReactHtmlParser(itemHeadingHtml)}
                  {ReactHtmlParser(itemSubHeadingHtml)}
                  {ReactHtmlParser(itemBodyCopyHtml)}
                  {cta.url && ctaText && (
                  <Link
                    to={cta.url}
                    ariaLabel={ariaLabel}
                    queryString={queryString}
                    lang={lang}
                  >
                    {ctaText}
                  </Link>
                  )}
                </Content>
              </Block>
            ),
          )}
        </Columns>
        {buttonText && buttonLink && (
          <StyledLink
            to={buttonLink.url}
            className={buttonType}
            ariaLabel={ariaLabelButton}
            queryString={queryStringButton}
            lang={lang}
          >
            {buttonText}
          </StyledLink>
        )}
        {image.url && imageSharp && (
          <OptionalImage src={imageSharp} alt={image.altTag} />
        )}
      </StyledContainer>
    </Wrapper>
  );
}

DataSection.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default DataSection;
